export default __webpack_public_path__ + "static/media/img4.365c7ed9.png";